import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimUploadPriceActsMutationVariables } from 'gql/graphql';
import { useSetIsWorkOrderChangeRequired } from 'pages/Project/BimProject/hooks/useSetIsWorkOrderChangeRequired';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { bimUploadPriceActsGql } from '../../bimWorkOrderQueries';

const requestId = 'bimUploadPriceActs';

export const useBimUploadActKc2Files = () => {
    const dispatch = useDispatch();

    const [
        bimUploadActKc2FilesData,
        bimUploadActKc2FilesStatus,
        bimUploadActKc2FilesError,
        makeRequest,
        ,
        abortRequest,
    ] = useRequest({
        requestId,
        query: bimUploadPriceActsGql,
        withEffect: false,
    });

    const [bimUploadActKc2FilesReset] = useResetStoreData({ requestId });

    const bimUploadActKc2FilesMakeRequest = useCallback(
        (variables: BimUploadPriceActsMutationVariables) => {
            dispatch(makeRequest(variables));
        },
        [dispatch, makeRequest],
    );

    const bimUploadActKc2FilesAbortRequest = useCallback(() => {
        dispatch(abortRequest());
    }, [abortRequest, dispatch]);

    useSetIsWorkOrderChangeRequired({
        useData: bimUploadActKc2FilesData?.bimUploadPriceActs?.data,
        status: bimUploadActKc2FilesStatus,
    });

    return {
        bimUploadActKc2FilesData: bimUploadActKc2FilesData?.bimUploadPriceActs,
        bimUploadActKc2FilesStatus,
        bimUploadActKc2FilesError,
        bimUploadActKc2FilesMakeRequest,
        bimUploadActKc2FilesReset,
        bimUploadActKc2FilesAbortRequest,
    };
};
